import { useParams, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getWatchTV } from "../../services/tv";
import FilmWatch from "../../components/FilmWatch/FilmWatch";
import Error from "../Error";

const TVWatch = () => {
  const { id } = useParams();
  const { isLoading, data, isError } = useQuery(["watchTV", id], () =>
    getWatchTV(Number(id))
  );

  const [queryParams] = useSearchParams();

  const seasonId = Number(queryParams.get("season")) || 1;
  const episodeId = Number(queryParams.get("episode")) || 1;

  if (isError) return <Error />;

  if (isLoading) return <div>Loading...</div>;

  const currentSeason = data.detailSeasons.find(
    (season) => season.season_number === seasonId
  );

  const currentEpisode = currentSeason?.episodes.find(
    (episode) => episode.episode_number === episodeId
  );

  if (!currentEpisode && data) return <Error />;

  return (
    <FilmWatch
      {...data}
      media_type="tv"
      seasonId={seasonId}
      episodeId={episodeId}
      currentEpisode={currentEpisode}
    />
  );
};

export default TVWatch;
